import script from "./authorization.vue?vue&type=script&setup=true&lang=jsx"
export * from "./authorization.vue?vue&type=script&setup=true&lang=jsx"

import "./authorization.vue?vue&type=style&index=0&id=517f6b80&lang=less"

const __exports__ = script;

export default __exports__